import React from 'react';
import { UsersIcon, SearchIcon, CheckCircleIcon, XIcon } from 'lucide-react';
import { mockUsers } from '../../../data/productManagerData';
import type { PM } from './useProductManager';
import { useDarkClasses } from '../../../hooks/useDarkClasses';
interface CollaboratorsSectionProps {
  pm: PM;
}
export const CollaboratorsSection: React.FC<CollaboratorsSectionProps> = ({
  pm
}) => {
  const dk = useDarkClasses();
  const {
    darkMode,
    productType,
    bookForm,
    merchForm,
    eventForm,
    bookBoxForm,
    collaboratorSearch,
    setCollaboratorSearch,
    showCollaboratorDropdown,
    setShowCollaboratorDropdown,
    selectedCollaboratorRole,
    setSelectedCollaboratorRole,
    collaboratorDropdownRef,
    handleAddCollaborator,
    handleRemoveCollaborator
  } = pm;
  const collaborators = productType === 'book' ? bookForm.collaborators : productType === 'merch' ? merchForm.linkedCreators : productType === 'event' ? eventForm.collaborators : bookBoxForm.collaborators;
  return <div className={`p-6 rounded-xl shadow-sm ${dk.card}`} data-id="element-20229" data-mp="3oac9xcwm2wa2">
      <h2 className={`text-lg font-bold mb-4 flex items-center ${dk.textHeading}`} data-id="element-20230" data-mp="3ta6xp7l3b5qw">
        <UsersIcon className="w-5 h-5 mr-2 text-purple-500" data-id="element-20231" data-mp="3fayv04ppxfhy" />
        Collaborators
      </h2>
      <div className="space-y-4" data-id="element-20232" data-mp="3jcaqurz6qwyl">
        <div className="relative" ref={collaboratorDropdownRef} data-id="element-20233" data-mp="3jff1a738uoxp">
          <div className="flex gap-2" data-id="element-20234" data-mp="35kw2e5mie3k5">
            <div className="relative flex-1" data-id="element-20235" data-mp="35k48cz8k8dvz">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" data-id="element-20236" data-mp="3acxg7vzbs2ca" />
              <input type="text" value={collaboratorSearch} onChange={e => {
              setCollaboratorSearch(e.target.value);
              setShowCollaboratorDropdown(true);
            }} onFocus={() => setShowCollaboratorDropdown(true)} className={`w-full pl-9 pr-3 py-2 rounded-md border ${dk.inputOnCard}`} placeholder="Search users to tag..." data-id="element-20237" data-mp="2vp2iu2adh9sv" />
            </div>
            <select value={selectedCollaboratorRole} onChange={e => setSelectedCollaboratorRole(e.target.value)} className={`w-32 sm:w-40 p-2 rounded-md border ${dk.inputOnCard}`} data-id="element-20238" data-mp="se67q0h3cdbv">
              <option value="Co-Writer" data-id="element-20239" data-mp="jcg9aaoske4l">Co-Writer</option>
              <option value="Editor" data-id="element-20240" data-mp="1g3qukugd7uqf">Editor</option>
              <option value="Cover Artist" data-id="element-20241" data-mp="1g2fnolrmi6v3">Cover Artist</option>
              <option value="Narrator" data-id="element-20242" data-mp="1b68gkpnhqpbk">Narrator</option>
              <option value="Illustrator" data-id="element-20243" data-mp="173lxpe8sseqi">Illustrator</option>
            </select>
          </div>
          {showCollaboratorDropdown && collaboratorSearch && <div className={`absolute z-10 w-full mt-1 rounded-md shadow-lg max-h-60 overflow-auto ${dk.card}`} data-id="element-20244" data-mp="1274wpjgi25w0">
              {mockUsers.filter(u => u.name.toLowerCase().includes(collaboratorSearch.toLowerCase())).map(user => <div key={user.id} className="px-4 py-2 cursor-pointer hover:bg-purple-50 dark:hover:bg-gray-600 flex items-center gap-2" onClick={() => handleAddCollaborator(user, selectedCollaboratorRole)} data-id="element-20245" data-mp="27ctoqht658a7">
                    <img src={user.avatar} alt={user.name} className="w-6 h-6 rounded-full" data-id="element-20246" data-mp="2l62so2ycl1lc" />
                    <div className="flex-1" data-id="element-20247" data-mp="2v2o4b74vhay5">
                      <p className="text-sm font-medium" data-id="element-20248" data-mp="2z3zsd883lo48">{user.name}</p>
                      <p className="text-xs text-gray-500" data-id="element-20249" data-mp="2z156rddclx98">
                        {user.roles.join(', ')}
                      </p>
                    </div>
                    {user.verified && <CheckCircleIcon className="w-4 h-4 text-blue-500" data-id="element-20250" data-mp="9fa6kxa3pii7" />}
                  </div>)}
            </div>}
        </div>
        <div className="space-y-2" data-id="element-20251" data-mp="5df8s2rdpn96">
          {collaborators?.map((collab, idx) => <div key={idx} className={`flex items-center justify-between p-3 rounded-lg border ${dk.surfaceMuted} ${dk.border}`} data-id="element-20252" data-mp="jcy4fw30764l">
              <div className="flex items-center gap-3" data-id="element-20253" data-mp="3mteulg798seb">
                <img src={collab.avatar} alt={collab.name} className="w-8 h-8 rounded-full" data-id="element-20254" data-mp="3mru0frourbgz" />
                <div data-id="element-20255" data-mp="g6nhtaxp33p">
                  <p className={`text-sm font-medium flex items-center gap-1 ${dk.textPrimary}`} data-id="element-20256" data-mp="gospffkqrnr">
                    {collab.name}
                    {collab.verified && <CheckCircleIcon className="w-3 h-3 text-blue-500" data-id="element-20257" data-mp="2z4lynjqmukjp" />}
                  </p>
                  <p className={`text-xs ${dk.textMuted}`} data-id="element-20258" data-mp="1em1nxz4g2fa7">
                    {collab.role} • {collab.status}
                  </p>
                </div>
              </div>
              <button onClick={() => handleRemoveCollaborator(idx)} className="text-gray-400 hover:text-red-500" data-id="element-20259" data-mp="1jf4m6kk62cwq">
                <XIcon className="w-4 h-4" data-id="element-20260" data-mp="19o9u2zk8oj3d" />
              </button>
            </div>)}
        </div>
      </div>
    </div>;
};